import { Alert } from '@mui/material';

export type LoadingErrorProps = {
  text?: string;
};

/**
 * Simple loading error
 */
export const LoadingError = ({ text }: LoadingErrorProps) => (
  <Alert severity='error'>{text || 'Loading Error'}</Alert>
);
